module.exports = __webpack_public_path__ + "static/media/healthCare.676609a8.jpg";